import createLazyComponent from '@src/utils/create-lazy-component';
import KvSectionStore from './components/kv-section/store';
import FeatureSectionStore from './components/feature-section/store';
import DownloadSectionStore from './components/download-section/store';

// 首页
const KvSection = createLazyComponent(() => import('@src/pages/main/components/kv-section'));
export const kvSectionStore = new KvSectionStore();

// 特色
const FeatureSection = createLazyComponent(() => import('@src/pages/main/components/feature-section'));
export const featureSectionStore = new FeatureSectionStore();

// 下载安装 & 关注我们
const DownloadSection = createLazyComponent(() => import('@src/pages/main/components/download-section'));
export const downloadSectionStore = new DownloadSectionStore();

export const SECTION_CONFIG = {
  // 首页
  KV: {
    order: 0,
    title: '首页',
    component: KvSection,
    store: kvSectionStore
  },
  // 特色
  FEATURE: {
    order: 1,
    title: 'PC特色',
    component: FeatureSection,
    store: featureSectionStore
  },
  // 下载安装 & 关注我们
  DOWNLOAD: {
    order: 2,
    title: '下载安装',
    component: DownloadSection,
    store: downloadSectionStore
  }
};
